<template>
  <div class="d-flex justify-content-center" >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card class="cardSe" style="width: 95%">
      <b-row>
        <b-col :class="cardAbierto === true ? 'tituloCard seleccionado' : 'tituloCard' " class="text-left d-flex align-items-center">
          Listado de tratamientos
        </b-col>
      </b-row>


      <b-collapse id="collapseDetail-hallazgo"
                  role="tabpanel" visible style="height: 600px; overflow-y: scroll" >
        <div v-for="(hallazgo, index) in
        opcionTabSeleccionadaProp == 1 ?  tratamientosOpcionNoAceptada.tratamientosHallazgos : tratamientosOpcionNoAceptada.tratamientosPrioridad"
             :key="index" >
          <b-card class="text-left" style="border: 0px;">

          <span  style="font-size: 11px; color: #79ACCE">
            <em class="dienteTratamiento"></em>
            {{hallazgo.tratamiento}}
          </span>
            <b-row class="m-0 bold">

              <b-col class="leterSize text-left p-0 columnas-col" style="width: 12%; border-right: #ECECEC 1px solid;">Od´s afectados</b-col>
              <b-col class="leterSize bordeTable text-left p-1 columnas-col">Padecimiento</b-col>
              <b-col class="leterSize bordeTable p-0 text-center columnas-col">Cantidad tratamiento</b-col>
              <b-col class="leterSize bordeTable p-0 text-center columnas-col" >Precio unitario</b-col>
            </b-row>

            <div v-for="(pad, ind1) in hallazgo.tratamientos" :key="'init-'+ind1">
              <b-row class="m-0">
                <b-col  class="leterSize text-center p-0 columnas-col" style="border-right: 1px solid #ECECEC">
                  <b-button size="sm" variant="outline-info" pill disabled class="ml-2 mr-2">
                    <span class="leterSize" v-if="pad.numeroDiente != 0">{{pad.numeroDiente}}</span>
                    <span class="leterSize" v-else>{{pad.nombreDiente}}</span>
                  </b-button>
                </b-col>
                <b-col class="leterSize bordeTable text-left p-1 d-flex align-items-center " :style="pad.estilos">
                  {{pad.padecimiento}}
                </b-col>
                <b-col class="leterSize bordeTable p-0 text-center columnas-col " :style="pad.estilos">
                  {{pad.cantidad}}
                </b-col>
                <b-col class="leterSize bordeTable p-0 text-center columnas-col " :style="pad.estilos">
                  {{pad.precioUnitario | moneda}}
                </b-col>

              </b-row>
<!--              <hr v-if="hallazgo.gth !== 1 && hallazgo.listPadecimientos.length !== ind1 + 1"
                  class="mt-2 mb-2">-->
            </div>
          </b-card>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "OpcionNoAceptada",
  props: {
    tratamientosHall: Array,
    tratamientosPrio: Array,
    opcionTabSeleccionadaProp: Number,
    tratamientosOpcionNoAceptada: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    cardAbierto: true
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },

}
</script>

<style scoped>
.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
}
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
.tituloCard.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
  color: #55C6B2;
}
.tituloCard{
  font-size: 10px !important;
  color: #717171;
}

.columnas-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-estatus-inicio {
  border-radius: 10px 0 0 10px;
  border-top: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-medio {
  border-top: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-final {
  border-radius: 0 10px 10px 0;
  border-top: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid
}
</style>